import { render, staticRenderFns } from "./CSwitch.vue?vue&type=template&id=0601d02d"
import script from "./CSwitch.vue?vue&type=script&lang=js"
export * from "./CSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports